module.exports = __webpack_public_path__ + "img/upi.aa8ae0ee.svg";